// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfilePhoto_container__2FKZ7","profileImage":"ProfilePhoto_profileImage__3C-oU","changeButton":"ProfilePhoto_changeButton__P0jjk"};